/**
 * Front-end mirror of the backend role permissions (see
 * backend/src/middleware/roleMiddleware.js). Used to decide which controls to
 * show; the backend still enforces every action.
 */

/** Roles that can create, run and correct test runs (testruns:write). */
export const TEST_RUN_MANAGER_ROLES = ['admin', 'qa', 'dev'];

/** True when the user may create/run/edit test runs (not just view them). */
export function canManageTestRuns(user) {
  return TEST_RUN_MANAGER_ROLES.includes(user?.role);
}

/** Roles that can create/edit/delete projects (projects:write). */
export const PROJECT_WRITER_ROLES = ['admin', 'qa', 'dev'];

/** Roles that can create/edit/delete test suites (testsuites:write). */
export const TEST_SUITE_WRITER_ROLES = ['admin', 'qa'];

/** Roles that can create/edit/delete test cases (testcases:write). */
export const TEST_CASE_WRITER_ROLES = ['admin', 'qa'];

export function canWriteProjects(user) {
  return PROJECT_WRITER_ROLES.includes(user?.role);
}

export function canWriteTestSuites(user) {
  return TEST_SUITE_WRITER_ROLES.includes(user?.role);
}

export function canWriteTestCases(user) {
  return TEST_CASE_WRITER_ROLES.includes(user?.role);
}
